export default __webpack_public_path__ + "static/media/sidebar-arrow-up.90ee8ad4.svg";